import React from 'react';

interface Props {
    title: string;
    phase: string;
    eta: string;
    description: string;
    integrations?: string[];
}

export const PlaceholderPage: React.FC<Props> = ({ title, phase, eta, description, integrations }) => {
    return (
        <div>
            <div className="flex items-center gap-3 mb-4">
                <h1 className="text-2xl font-bold">{title}</h1>
                <span className="px-2 py-1 text-xs uppercase tracking-wider rounded-full bg-primary-light/10 text-primary-light dark:bg-primary-dark/10 dark:text-primary-dark">
                    {phase}
                </span>
            </div>
            <div className="bg-white dark:bg-content-dark rounded-xl border border-border-light dark:border-border-dark p-6 max-w-2xl">
                <p className="text-sm mb-3">{description}</p>
                <p className="text-xs text-text-secondary-light dark:text-text-secondary-dark mb-4">
                    <strong>ETA:</strong> {eta}
                </p>
                {integrations && integrations.length > 0 && (
                    <div>
                        <p className="text-xs font-semibold text-text-secondary-light dark:text-text-secondary-dark mb-1">
                            Wymagane integracje:
                        </p>
                        <ul className="text-xs space-y-1">
                            {integrations.map(i => (
                                <li key={i} className="text-text-secondary-light dark:text-text-secondary-dark">• {i}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};
